module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-111.8a7a066f.svg";